import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LinkGroupActions, LinkGroupActionTypes } from '../_actions/link-group.actions';
import { LinkGroup } from '../_models/link-group.model';
import { QueryParamsModel } from '../../_base/crud';

export interface LinkGroupsState extends EntityState<LinkGroup> {
  linkGroups: LinkGroup[];
  totalCount: number;
  error: any;
  latestSuccessfullyAction: any;
  listLoading: boolean;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<LinkGroup> = createEntityAdapter<LinkGroup>();

export const initialLinkGroupsState: LinkGroupsState = adapter.getInitialState({
  linkGroups: [],
  totalCount: 0,
  error: null,
  latestSuccessfullyAction: null,
  listLoading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
});

export function linkGroupsReducer(
  state = initialLinkGroupsState,
  action: LinkGroupActions,
): LinkGroupsState {
  switch (action.type) {
    case LinkGroupActionTypes.LinkGroupsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
      };
    case LinkGroupActionTypes.LinkGroupsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case LinkGroupActionTypes.LinkGroupsPageLoaded: {
      return adapter.addMany(action.payload.linkGroups, {
        ...initialLinkGroupsState,
        totalCount: action.payload.totalCount,
        showInitWaitingMessage: false,
        lastQuery: action.payload.page,
        latestSuccessfullyAction: state.latestSuccessfullyAction,
        linkGroups: state.linkGroups,
        error: null,
      });
    }
    case LinkGroupActionTypes.LinkGroupsLoaded:
      return {
        ...state,
        linkGroups: action.payload.linkGroups,
      };
    case LinkGroupActionTypes.ThrowLinkGroupError: {
      return {
        ...state,
        error: action.payload.error,
      };
    }
    case LinkGroupActionTypes.FireLinkGroupSuccess: {
      return {
        ...state,
        latestSuccessfullyAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    case LinkGroupActionTypes.ClearLinkGroupState: {
      return initialLinkGroupsState;
    }
    default:
      return state;
  }
}

export const getLinkGroupState = createFeatureSelector<LinkGroupsState>('linkGroups');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
